import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { useForm } from 'react-hook-form'

import useTranslate from '../../../../lib/hooks/use-translate'
import { OlContactInput } from '../../../../lib/types/models/ol/ol-input'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'
import ControlledPhoneInput from '../../../elements/inputs/controlled-phone-input'
import ValidationButtons from '../../../elements/validation-buttons'
import { OL_CONTACT_FORM_SCHEMA_VALIDATION } from '../utils'

type Props = BaseFormProps<OlContactInput, true> & {
  className?: string
}

const OlContactForm = ({ className, defaultValues, ...validationButtonProps }: Props) => {
  const { t } = useTranslate()
  const form = useForm<OlContactInput>({
    resolver: zodResolver(OL_CONTACT_FORM_SCHEMA_VALIDATION(t)),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('grid grid-cols-2 gap-3 w-full', className)}>
          <FormField
            control={form.control}
            name="lastName"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} required type="text" label="NOM" />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="firstName"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} required type="text" label="Prénom" />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} required type="email" label="Email" />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name={'phone'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledPhoneInput
                    {...field}
                    required
                    label={'Numéro de téléphone'}
                    defaultCountry={'FR'}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="position"
            render={({ field }) => (
              <FormItem className="col-span-2">
                <FormControl>
                  <ControlledInput {...field} required type="text" label="Poste" />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default OlContactForm
